import React from 'react';

const Dtc = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 20" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Dtc_a"
        d="M612.78 270.76c.48 0 .88.47.88 1.01v14.47c0 .54-.4 1-.88 1h-24.14c-.48 0-.88-.46-.88-1v-14.47c0-.54.4-1 .88-1h24.14m0-1.77h-24.14a2.71 2.71 0 0 0-2.64 2.77v14.46a2.71 2.71 0 0 0 2.64 2.77h24.13a2.71 2.71 0 0 0 2.64-2.77v-14.46a2.71 2.71 0 0 0-2.64-2.77"
      />
      <path id="Dtc_b" d="M604.13 275.58h-2.55v8.58h-2.08v-8.58h-2.51v-1.73h7.14z" />
      <path
        id="Dtc_c"
        d="M607.1 281.12c.05.34.13.62.25.83.11.22.27.37.46.47a2.3 2.3 0 0 0 1.4.07.93.93 0 0 0 .44-.29c.12-.13.21-.32.27-.56.06-.24.1-.55.12-.92h2.08c-.06 1.18-.39 2.07-1 2.67-.6.6-1.46.9-2.57.9-.57 0-1.08-.09-1.53-.28a2.9 2.9 0 0 1-1.13-.84 3.9 3.9 0 0 1-.7-1.38 6.72 6.72 0 0 1-.25-1.9v-1.76c0-.71.08-1.35.25-1.9.17-.55.41-1.01.73-1.39.31-.37.7-.65 1.14-.84.45-.2.96-.29 1.52-.29 1.12 0 1.97.31 2.56.94.58.63.91 1.53 1 2.7h-2.1c0-.36-.04-.67-.1-.92a1.48 1.48 0 0 0-.24-.59.92.92 0 0 0-.45-.31 2.14 2.14 0 0 0-1.38.05c-.2.1-.36.24-.48.45-.12.21-.21.5-.27.83a7.5 7.5 0 0 0-.1 1.26v1.77c0 .48.03.9.08 1.23"
      />
      <path
        id="Dtc_d"
        d="M596.28 276.36a3.45 3.45 0 0 0-2.06-2.22c-.49-.2-1.03-.29-1.63-.29h-2.72v10.3h2.7c.6 0 1.15-.1 1.65-.29a3.44 3.44 0 0 0 2.06-2.2c.2-.54.29-1.16.29-1.85v-1.6c0-.7-.1-1.31-.3-1.85zm-1.8 3.46c0 .46-.03.86-.09 1.2-.06.33-.16.6-.3.81-.15.21-.35.37-.6.46-.24.1-.55.15-.92.15h-.62v-6.86h.64c.36 0 .66.05.9.15.25.1.45.25.6.46.14.2.24.47.3.8.06.33.1.74.1 1.2z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Dtc_a" transform="translate(-586 -269)" />
    <use fill="currentColor" xlinkHref="#Dtc_b" transform="translate(-586 -269)" />
    <use fill="currentColor" xlinkHref="#Dtc_c" transform="translate(-586 -269)" />
    <use fill="currentColor" xlinkHref="#Dtc_d" transform="translate(-586 -269)" />
  </svg>
);

export default Dtc;



// WEBPACK FOOTER //
// ./src/common/icons/Dtc.js